import React from 'react'
import { useSelector } from 'react-redux'
import SingleSelect from '../singleSelect/SingleSelect.component'
import { getCrewListDataSelector } from '../../features/crew/selectors'
import { IOption } from '../../common/common.types'
import { IPHIComponent } from '../phi/phi.component'

export interface ICrewInputProps extends IPHIComponent {
  dataTestID: string
  label?: string
  listHeader?: string
  selectedOption?: IOption | null
  action: (option: IOption | null, dispatchData?: any) => void
  dispatchData?: any
  disabled?: boolean
  hideClearButton?: boolean
  reduxAction?: string
}

const CrewInput: React.FC<ICrewInputProps> = (props: ICrewInputProps) => {
  const {
    dataTestID,
    label,
    listHeader,
    selectedOption,
    action,
    dispatchData,
    isPHI,
    disabled,
    hideClearButton,
    reduxAction,
  } = props

  const crewListData = useSelector(getCrewListDataSelector)

  return (
    <SingleSelect
      dataTestID={dataTestID}
      label={label}
      listHeader={listHeader || label}
      options={crewListData}
      selectedOption={selectedOption}
      action={action}
      dispatchData={dispatchData}
      isPHI={isPHI}
      disabled={disabled}
      hideClearButton={hideClearButton}
      reduxAction={reduxAction}
    />
  )
}

export default CrewInput
